import React from 'react'
import type { IdentityInfoProps } from '@/features/enrollment'

export default function PFASIdentityInfo({ enrollmentData, updateEnrollmentData, errors }: IdentityInfoProps) {
  return (
    <>
      {/* Date of Birth */}
      <div>
        <label className="block text-sm font-medium text-accent-700 mb-2">
          Date of Birth <span className="text-red-500">*</span>
        </label>
        <input 
          type="date" 
          name="injuredPartyDOB"
          className={`input-field ${errors.injuredPartyDOB ? 'border-red-500' : ''}`} 
          value={enrollmentData.injuredPartyDOB || ''} 
          onChange={(e) => updateEnrollmentData('injuredPartyDOB', e.target.value)}
          max={new Date().toISOString().split('T')[0]}
        />
        {errors.injuredPartyDOB && (
          <p className="mt-1 text-sm text-red-600">{errors.injuredPartyDOB}</p>
        )}
      </div>
    </>
  )
}
